/**
 * localStorage操作
 * 存储、读取、删除
 */
const Local = {
  set(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    return localStorage.setItem(key, value);
  },
  get(key) {
    let value = localStorage.getItem(key);
    if (/^\{.*\}$/.test(value)) {
      value = JSON.parse(value);
    }
    return value;
  },
  remove(key) {
    return localStorage.removeItem(key);
  }
};

export default Local;